export function SwitchHorizontal() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M3.33398 14.1667H16.6673M16.6673 14.1667L13.334 10.8333M16.6673 14.1667L13.334 17.5M16.6673 5.83333H3.33398M3.33398 5.83333L6.66732 2.5M3.33398 5.83333L6.66732 9.16667"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
